import "../shared/league.css";
import SwissLeagueDemo from "./demo";

/**
 * Bản mô phỏng thể thức Swiss tại /league-swiss - đi qua 9 trạng thái của cơ
 * thủ mà không cần backend, chỉ bật khi REACT_APP_SWISS_DEMO=true (dev/staging).
 *
 * Giải Swiss thật không có URL riêng: /league/:id và /league/:id/detail tự rẽ
 * nhánh sang SwissLeagueLive khi league.type === 'SWISS'.
 */
export default function SwissLeaguePage() {
  if (process.env.REACT_APP_SWISS_DEMO === "true") {
    return <SwissLeagueDemo />;
  }

  return (
    <div className="biadi">
      <div className="shell">
        <div className="pad">
          <div className="emptybox">Chọn một giải Swiss từ danh sách giải đấu để xem chi tiết.</div>
        </div>
      </div>
    </div>
  );
}
